import Typography from '@mui/material/Typography'

import type { AssignedBijlage } from '../../entity/bijlagen/types/AssignedBijlage'

interface Props {
  assignedBijlage: AssignedBijlage
}

const generateCaption = ({
  status,
  reden,
  waitFor,
  completed,
  requiresReview,
  subprocesId,
  subprocesType,
}: AssignedBijlage): string | null => {
  if (status === 'review') {
    return 'Te beoordelen'
  }

  if (status === 'waiting' && waitFor) {
    return `Wacht op ${waitFor}`
  }

  if (reden) {
    return 'Opnieuw opleveren na afkeur'
  }

  if (status === 'cancelled') {
    return 'Geannuleerd'
  }

  if (requiresReview && !completed) {
    return 'Ter beoordeling aanbieden'
  }

  if (subprocesType) {
    return `Onderdeel van subproces ${subprocesType}`
  } else if (subprocesId) {
    return 'Onderdeel van een subproces'
  }

  return null
}

export const AssignedBijlageCaption = ({ assignedBijlage }: Props) => {
  const caption = generateCaption(assignedBijlage)

  if (!caption) return null

  return (
    <>
      <br />
      <Typography variant="caption">
        <span></span>
        {caption}
      </Typography>
    </>
  )
}
